    <div class="low-navbar-account">
        <ul>
            @for(item of navItems; track item.item){
                <li [ngClass]="{'nav-item-active' : item.active, 'nav-item': !item.active}">
                    <a (click)="triggerAction(item.item)">{{ item.name }}</a>
                </li>
            }
        </ul>
        <hr>
    </div>

    <app-activities *ngIf="navItems[0].active"></app-activities>
    <app-nav-prepusueto *ngIf="navItems[2].active"></app-nav-prepusueto>
    <app-nav-stagehistory *ngIf="navItems[3].active"></app-nav-stagehistory>
    <app-nav-contact-functions *ngIf="navItems[4].active"></app-nav-contact-functions>
    <app-nav-files *ngIf="navItems[6].active"></app-nav-files>

